// extracted by mini-css-extract-plugin
export default {"AuthNav":"AuthNav_AuthNav__oLtye","link":"AuthNav_link__-75bU"};